import Divider from "@material-ui/core/Divider";
import Grid from "@material-ui/core/Grid";
import AppBar from "@material-ui/core/AppBar";
import Avatar from "@material-ui/core/Avatar";
import Badge from "@material-ui/core/Badge";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import makeStyles from "@material-ui/core/styles/makeStyles";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import NotificationsOutlined from "@material-ui/icons/NotificationsOutlined";
import React, { useContext, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import profileCircle from "../../assets/images/profileCircle.webp";
import { userJourneyContext } from "../../states/context/userJourneyContext";
import { USER_NAME } from "./mockModalData";
import MockTooltipComponent from "./MockTooltipComponent";
import { getProgress, updateUserJourneyState } from "./mockUtils";

const drawerWidth = 240;

const mockInfo = [
  {
    title: "Supplier Location Risk for ",
    name: "Taipei Textiles ",
    id: "PO#12087633979-A",
    content:
      "Taiwan's military for the first time shot down an unidentified civilian drone that entered its airspace near an islet that sits next door to China’s Xiamen city on Thursday . Incident came after Taiwan had repeatedly complained of harassment by drones coming from China and flying right up close to the Kinmen islands .",
    when: "just now",
  },
  {
    title: "Communication Risk for ",
    name: "Shunpeng Textiles",
    id: "PO#12087633979-B",
    content:
      "Supplier has not responded to an update for the latest delivery date",
    when: "2hr ago ",
  },
  {
    title: "Delivery Date Risk for ",
    name: "Arisudana Industries Limited",
    id: "PO#12087633979-D",
    content: "Supplier has given a new delivery date which is 13 days late",
    when: "12hr ago",
  },
  {
    title: "Logistics Risk for ",
    name: "CMC Textiles",
    id: "PO#12087633979-C ",
    content: "Vessel ETA has increased by 43 hours",
    when: "1day ago",
  },
];

const MockHeaderComponent = (props) => {
  const classes = useStyles();
  const userContext = useContext(userJourneyContext);
  const history = useHistory();
  const [notificationOpen, setNotificationOpen] = useState(false);
  const [menuTooltip, setMenuTooltip] = useState(false);

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const makeApiCall = () => {
    (async () => {
      try {
        userContext.setUserJourneyInfo(
          updateUserJourneyState(userContext.userJourneyInfo)
        );
        userContext.setUserJourneyProgress(
          getProgress(userContext.userJourneyProgress)
        );
      } catch (e) {
        console.log(e);
      }
    })();
  };

  const clickOpenNotifications = (event) => {
    setNotificationOpen(false);
    setMenuTooltip(true);
    setAnchorEl(event.currentTarget);
    if (userContext.userJourneyInfo.payload.steps === 5) {
      makeApiCall();
    }
  };

  useEffect(() => {
    if (userContext.userJourneyInfo.payload.title === "Filter By Ex-Mill Date") {
      setNotificationOpen(true);
    } else {
      setNotificationOpen(false);
    }
  }, [userContext.userJourneyInfo.payload]);

  const MockInfoBar = () => {
    return (
      <Menu
        anchorEl={anchorEl}
        id="account-menu"
        open={open}
        PaperProps={{
          elevation: 2,
          style: {
            marginTop: "73px",
            maxHeight: "680px",
            width: "350px",
            right: "1%",
            top: 0,
            left: 0,
            marginLeft: `calc(100% - 380px)`,
            overflow: "hidden"
          },
        }}
        classes={{
          list: classes.menuListContainer,
        }}
      >
        {mockInfo.map((info, i) =>
          i === 0 ? (
            <MockTooltipComponent
              title={
                <>
                  <Typography className={classes.tooltipTitleStyle}>
                    Risks to your orders
                  </Typography>
                  <p className={classes.tooltipTextStyle}>
                    We’ve detected risks to your orders which could impact the
                    delivery date.
                    <span className={classes.newLine}>
                      Clicking on risks will let you take a closer look and help determine impacts.
                    </span>
                  </p>
                  <div
                    style={{
                      width: "64px",
                      padding: "8px",
                      backgroundColor: "#ffffff",
                      color: "#000000",
                      fontWeight: 600,
                      borderRadius: "4px",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      if (userContext.userJourneyInfo.payload.steps === 6) {
                        setMenuTooltip(false);
                        setAnchorEl(null)
                        history.push("/kavida/tour/milestone-tracker");
                        makeApiCall();
                      }
                    }}
                  >
                    <span>Continue</span>
                  </div>
                  <Typography className={classes.stepTextStyle}>
                    (4/19)
                  </Typography>
                </>
              }
              placement="left-end"
              open={menuTooltip}
              popper={classes.notificationTooltip}
              tooltipArrowStyle={classes.locationArrowStyle}
              child={
                <>
                  <MenuItem
                    classes={{
                      root: classes.menuItemStyle,
                    }}
                  >
                    <Badge
                      color="secondary"
                      variant="dot"
                      overlap="circular"
                      anchorOrigin={{
                        vertical: "top",
                        horizontal: "left",
                      }}
                      classes={{
                        anchorOriginTopLeftCircular: classes.badgeStyle1,
                      }}
                    >
                      <Grid
                        container
                        className={classes.menuBarContainer}
                        onClick={() => {
                          if (userContext.userJourneyInfo.payload.steps === 6) {
                            setMenuTooltip(false);
                            setAnchorEl(null)
                            history.push("/kavida/tour/milestone-tracker");
                            makeApiCall();
                          }
                        }}
                      >
                        <Grid item xs={10}>
                          <Grid container>
                            <Grid item xs={12}>
                              <Typography
                                variant="caption"
                                className={classes.textStyle}
                              >
                                {info.title}
                              </Typography>
                            </Grid>
                            <Grid item xs={12}>
                              <Typography
                                variant="caption"
                                className={classes.idStyle}
                              >
                                {info.name}
                              </Typography>
                            </Grid>
                            <Grid item xs={12}>
                              <Typography
                                variant="caption"
                                className={classes.idStyle}
                              >
                                {info.id}
                              </Typography>
                            </Grid>
                            <Grid item xs={12} className={classes.contentStyle}>
                              <Typography
                                variant="caption"
                                className={classes.textStyle}
                              >
                                {info.content}
                              </Typography>
                            </Grid>
                          </Grid>
                        </Grid>
                        <Grid item xs={2}>
                          <Typography
                            noWrap
                            variant="caption"
                            className={classes.notificationTimeStyle}
                          >
                            {info.when}
                          </Typography>
                        </Grid>
                      </Grid>
                    </Badge>
                  </MenuItem>
                  {i <= mockInfo.length - 1 && <Divider />}
                </>
              }
            />
          ) : (
            <>
              <MenuItem
                classes={{
                  root: classes.menuItemStyle,
                }}
              >
                <Badge
                  color="secondary"
                  variant="dot"
                  overlap="circular"
                  anchorOrigin={{
                    vertical: "top",
                    horizontal: "left",
                  }}
                  classes={{
                    anchorOriginTopLeftCircular: classes.badgeStyle2,
                  }}
                >
                  <Grid
                    container
                    className={classes.menuBarContainer}
                    onClick={() => {
                      if (userContext.userJourneyInfo.payload.steps === 6) {
                        setMenuTooltip(false);
                        setAnchorEl(null)
                        history.push("/kavida/tour/milestone-tracker");
                        makeApiCall();
                      }
                    }}
                  >
                    <Grid item xs={10}>
                      <Grid container>
                        <Grid item xs={12}>
                          <Typography
                            variant="caption"
                            className={classes.textStyle}
                          >
                            {info.title}
                          </Typography>
                        </Grid>
                        <Grid item xs={12}>
                          <Typography
                            variant="caption"
                            className={classes.idStyle}
                          >
                            {info.name}
                          </Typography>
                        </Grid>
                        <Grid item xs={12}>
                          <Typography
                            variant="caption"
                            className={classes.idStyle}
                          >
                            {info.id}
                          </Typography>
                        </Grid>
                        <Grid item xs={12} className={classes.contentStyle}>
                          <Typography
                            variant="caption"
                            className={classes.textStyle}
                          >
                            {info.content}
                          </Typography>
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid item xs={2}>
                      <Typography
                        noWrap
                        variant="caption"
                        className={classes.notificationTimeStyle}
                      >
                        {info.when}
                      </Typography>
                    </Grid>
                  </Grid>
                </Badge>
              </MenuItem>
              {i <= mockInfo.length - 1 && <Divider />}
            </>
          )
        )}
      </Menu>
    );
  };

  return (
    <div>
      <AppBar position="fixed" className={classes.appBar}>
        <Toolbar>
          <Grid
            container
            direction="row"
            alignItems="center"
            spacing={1}
            className={classes.toolbarContainer}
          >
            <Grid item xs={8}>
              <div style={{ flex: 1 }}>
                <Typography className={classes.heading} variant="h5" noWrap>
                  {props.title}
                </Typography>
              </div>
            </Grid>
            <Grid
              container
              item
              xs={4}
              direction="row"
              justifyContent="flex-end"
              alignItems="center"
              spacing={1}
            >
              <Grid item>
                <MockTooltipComponent
                  title={
                    <>
                      <Typography className={classes.tooltipTitleStyle}>
                        Check Notifications
                      </Typography>
                      <p className={classes.tooltipTextStyle}>
                        You have notifications waiting for you about your
                        purchase orders.
                        <span className={classes.newLine}>
                        Click <NotificationsOutlined style={{ marginBottom:"-7px" }} /> icon to find out more.
                        </span>
                      </p>
                      <Typography className={classes.stepTextStyle}>
                        (3/19)
                      </Typography>
                    </>
                  }
                  placement="bottom"
                  popper={classes.checkNotificationTooltip}
                  open={notificationOpen}
                  child={
                    <Badge
                      color="secondary"
                      variant="dot"
                      overlap="circular"
                      onClick={(e) => {
                        if (userContext.userJourneyInfo.payload.steps === 5 || userContext.userJourneyInfo.payload.steps === 6) {
                          clickOpenNotifications(e)
                        }
                      }}>
                      <NotificationsOutlined style={{ cursor: "pointer" }} />
                    </Badge>
                  }
                />
                {anchorEl && <MockInfoBar />}
              </Grid>
              <Grid item xs={6} md={6} container justifyContent="center">
                <Typography
                  className={classes.profileName}
                  variant="body1"
                  noWrap
                >
                  {USER_NAME}
                </Typography>
              </Grid>
              <Grid item>
                <Avatar
                  style={{ cursor: "pointer" }}
                  alt=""
                  src={profileCircle}
                  className={classes.notificationStyle}
                />
              </Grid>
            </Grid>
          </Grid>
        </Toolbar>
      </AppBar>
    </div>
  );
};

const useStyles = makeStyles((theme) => ({
  appBar: {
    width: `calc(100% - ${drawerWidth}px)`,
    marginLeft: drawerWidth,
    backgroundColor: "#fff",
    color: "#000000",
  },
  toolbarContainer: {
    marginTop: "22px",
    marginBottom: "14px",
  },
  heading: {
    fontFamily: "Inter",
    fontSize: "24px",
    fontWeight: 700,
    color: "#252733",
    marginLeft: "16px",
  },
  profileName: {
    fontFamily: "Inter",
    fontSize: "22px",
    fontWeight: 600,
    color: "#252733",
    lineHeight: "20px",
  },
  textStyle: {
    fontFamily: "Inter",
    fontSize: "12px",
    fontWeight: 400,
  },
  idStyle: {
    fontFamily: "Inter",
    fontSize: "12px",
    fontWeight: 400,
    marginBottom: "20px",
  },
  menuBarContainer: {
    width: "315px",
    marginLeft: "16px",
    marginLeft: "21px",
  },
  menuItemStyle: {
    whiteSpace: "normal",
    lineHeight: "16.5px",
    paddingRight: "8px",
  },
  contentStyle: {
    maxWidth: "95%",
    marginTop: "24px",
  },
  menuListContainer: {
    padding: 0,
  },
  notificationTimeStyle: {
    fontFamily: "Inter",
    fontSize: "10px",
    fontWeight: 400,
  },
  badgeStyle1: {
    top: "3%",
    left: "2%",
  },
  badgeStyle2: {
    top: "7%",
    left: "2%",
  },
  tooltipTextStyle: {
    marginTop: "8px",
    fontSize: "14px",
    fontFamily: "Inter",
    lineHeight: "20px",
    fontWeight: 400,
  },
  tooltipTitleStyle: {
    fontSize: "20px",
    fontFamily: "Inter",
    fontWeight: 600,
  },
  notificationTooltip: {
    width: "280px",
    height: "140px",
    marginRight: '-20px',
    marginBottom: "-50px"
  },
  locationArrowStyle: {
    top: "60px !important",
  },
  stepTextStyle: {
    padding: "0px",
    margin: "0px",
    fontSize: "14px",
    textAlign: "end",
    marginTop: "-10px",
    marginBottom: "-10px",
  },
  checkNotificationTooltip: {
    marginTop: "-23px"
  },
  newLine: {
    display: "block",
    marginTop: "15px"

  }
}));

export default MockHeaderComponent;
